import servicio from '@/services/servicio-base'

const servicioCambioPrecio = {}

servicioCambioPrecio.getArticulosCambioPrecio = function(){
    return servicio.get(`/cambio-precio/articuloscambioprecio/`)
        .then( r => {
            return r.data;
        })
        .catch( error => {
            return error;
        })
}

export default servicioCambioPrecio